export const boardSettingTour = {
  key: "boardSetting",
  version: 2,
  getSteps: (t) => [
    {
      target: '[data-tour="board-setting-header"]',
      content: t("Tour_BoardSetting_Header"),
      placement: "bottom",
      disableBeacon: true,
    },
    {
      target: '[data-tour="board-setting-actions"]',
      content: t("Tour_BoardSetting_Actions"),
      placement: "left",
      disableBeacon: true,
    },
    {
      target: '[data-tour="board-setting-profile"]',
      content: t("Tour_BoardSetting_Profile"),
      placement: "top",
      disableBeacon: true,
    },
    {
      target: '[data-tour="board-setting-features"]',
      content: t("Tour_BoardSetting_Features"),
      placement: "right",
      disableBeacon: true,
    },
  ],
};
